
export class DPTitleBatchRequest {
    titles: string[];
}




// WEBPACK FOOTER //
// ./src/app/portalv1/model/dp-title-batch-request.ts